import { API_URL_V3 } from 'constants/index';
import { fetch } from 'services/apiV3/fetch';
import { fetchJson } from 'utils/fetchJson/fetchJson';

type CreatePayload = {
  orderId: string;
  token: string;
  locale: string;
  hideUserManagement: boolean;
  recurring: boolean;
  captchaResponse: string;
  platform: string;
  recipient: string;
};

interface PaymentsService {
  create: (payload: CreatePayload) => Promise<any>;
}

const payments: PaymentsService = {
  create: ({
    orderId,
    token,
    locale = 'EN',
    hideUserManagement = false,
    recurring,
    captchaResponse,
    platform,
    recipient,
  }) => {
    const queryParams = [
      `token=${token}`,
      `locale=${locale}`,
      ...(hideUserManagement ? ['hideUserManagement=true'] : []),
    ].join('&');
    const path = `${API_URL_V3}/orders/${orderId}/payments?${queryParams}`;
    const body = JSON.stringify({
      ...{ captcha_response: captchaResponse },
      ...(recurring && { recurring }),
      platform,
      recipient,
    });
    const options = { method: 'POST', body };

    if (recurring) {
      return fetch(path, options);
    }
    return fetchJson(path, options);
  },
};

export { payments };
